import React from 'react';
import PropTypes from 'prop-types';

import HotelMap from '../../containers/HotelMap';
import Searcher from '../../containers/SearcherContainer';
import ReviewsMobile from '../Reviews/ReviewsMobile';
import { HOTEL_MOBILE_PAGES } from '../../constants';
import { HEADER_OFFSET } from '../../../../constants/header';

const components = {
  [HOTEL_MOBILE_PAGES.MAP]: (
    <HotelMap height={`calc(100vh - ${HEADER_OFFSET}px)`} />
  ),
  [HOTEL_MOBILE_PAGES.REVIEWS]: <ReviewsMobile />,
  [HOTEL_MOBILE_PAGES.SEARCHER]: <Searcher isMobile />,
};

const MobileComponent = ({ name }) => components[name];

MobileComponent.propTypes = {
  name: PropTypes.string.isRequired,
};

export default MobileComponent;
